import { Clock, CheckCircle } from 'lucide-react';

interface ImplementationTimelineProps {
  painPoints: string[];
  recommendedTools: any[];
}

export function ImplementationTimeline({ painPoints, recommendedTools }: ImplementationTimelineProps) {
  const phases = [
    {
      title: 'Phase 1: Initial Setup and Assessment (Weeks 1-2)',
      tasks: [
        'Detailed analysis of current workflows',
        'Infrastructure assessment and preparation',
        'Team training needs assessment',
        'Initial pilot group selection'
      ]
    },
    {
      title: 'Phase 2: Pilot Implementation (Weeks 3-6)',
      tasks: [
        'Deploy solutions for pilot group',
        'Initial training sessions',
        'Gather feedback and metrics',
        'Adjust implementation strategy'
      ]
    },
    {
      title: 'Phase 3: Organization-wide Rollout (Weeks 7-12)',
      tasks: [
        'Expand deployment to all teams',
        'Comprehensive training program',
        'Integration with existing systems',
        'Establish support processes'
      ]
    },
    {
      title: 'Phase 4: Optimization and Scale (Weeks 13+)',
      tasks: [
        'Monitor adoption metrics',
        'Performance optimization',
        'Advanced feature rollout',
        'Long-term support structure'
      ]
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6">
      <div className="flex items-center mb-6">
        <Clock className="h-5 w-5 text-blue-500 dark:text-blue-400" />
        <h2 className="ml-2 text-lg font-semibold text-gray-900 dark:text-white">
          Implementation Timeline
        </h2>
      </div>

      <div className="space-y-8">
        {phases.map((phase, phaseIndex) => (
          <div key={phaseIndex} className="relative">
            {phaseIndex < phases.length - 1 && (
              <div className="absolute top-8 bottom-0 left-4 w-0.5 bg-gray-200 dark:bg-gray-700" />
            )}
            
            <div className="relative flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 dark:bg-blue-900/50 rounded-full flex items-center justify-center">
                <CheckCircle className="h-4 w-4 text-blue-600 dark:text-blue-400" />
              </div>
              <div className="ml-4 min-w-0">
                <h3 className="text-base font-medium text-gray-900 dark:text-white">
                  {phase.title}
                </h3>
                <ul className="mt-2 space-y-2">
                  {phase.tasks.map((task, taskIndex) => (
                    <li 
                      key={taskIndex}
                      className="flex items-start text-sm text-gray-600 dark:text-gray-400"
                    >
                      <span className="w-1.5 h-1.5 mt-1.5 rounded-full bg-gray-400 dark:bg-gray-500 flex-shrink-0" />
                      <span className="ml-2">{task}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}